module.exports = __webpack_public_path__ + "img/191.b202dd20.jpg";